import { render, staticRenderFns } from "./HaberlerDuzenle.vue?vue&type=template&id=5255ce4a&scoped=true&"
import script from "./HaberlerDuzenle.vue?vue&type=script&lang=js&"
export * from "./HaberlerDuzenle.vue?vue&type=script&lang=js&"
import style0 from "./HaberlerDuzenle.vue?vue&type=style&index=0&id=5255ce4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5255ce4a",
  null
  
)

export default component.exports